// START GENAI
import React, { useState } from "react";
import { Row, Col, Button, Input, Form, Divider, message } from "antd";
import { POST } from "_helpers/Fetch";

const API_URL = process.env.REACT_APP_API_URL;

const quickUsers = [
    { userId: "usrgl7090u", label: "usrgl7090u - Super Admin" },
    { userId: "useus9172u", label: "useus9172u - Tools Admin" },
    { userId: "bzxf51970u", label: "bzxf51970u - 3DS User - External (Subscription Manager)" },
    { userId: "usecl4333u", label: "usecl4333u  - Store Admin" },
    { userId: "useus5275u", label: "useus5275u - 3DS User - Visa Staff" },
    { userId: "bicj19520a", label: "bicj19520a - 3DS User - External (VMID Acquirer)" },
    { userId: "fccz79908f", label: "fccz79908f - 3DS User - External (BID)" }
];

export default function DevLoginPage({ onLogin }) {
    const [userId, setUserId] = useState("");
    const [loading, setLoading] = useState(false);

    function clearAllCookies() {
        // Get all cookies for the current domain
        document.cookie.split(";").forEach((cookie) => {
            const name = cookie.split("=")[0].trim();

            // To delete, set the cookie's expiry date to a past date.
            // Set path to / to cover as much as possible.
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        });
    }

    const onFinish = (values) => {
        setLoading(true);
        setTimeout(() => {
            message.success(`Logged in as ${values.userId}`);
            setLoading(false);
            // Here you can redirect or set auth context for local dev
        }, 1000);
    };

    const handleQuickLogin = async (userId) => {
        try {
            clearAllCookies();
            const response = await POST(`${API_URL}/Account/Login`, { userId });
            if (response.status === 200) {
                // Optional: refetch user claims and call onLoginSuccess with new userData
                // Or use response.data if your API returns user info
                onLogin && onLogin();
            } else {
                console.error("Login failed: " + response.statusText);
            }
        } catch (err) {
            console.error("Login error: " + (err.response?.data?.message || err.message));
        }
    };

    const handlePublicLogin = async () => {
        setLoading(true);
        try {
            clearAllCookies();
            const response = await POST(`${API_URL}/Account/publicLogin`, null);
            if (response.status === 200) {
                // Optional: refetch user claims and call onLoginSuccess with new userData
                // Or use response.data if your API returns user info
                onLogin && onLogin();
            } else {
                console.error("Login failed: " + response.statusText);
            }
        } catch (err) {
            console.error("Login error: " + (err.response?.data?.message || err.message));
        }
    };

    return (
        <div style={{ maxWidth: 650, margin: "40px auto", padding: 32, background: "#fff", borderRadius: 8 }}>
            <Row>
                <Col span={24}>
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={{ userId }}
                    >
                        <h4>Use a local account to log in.</h4>
                        <Divider />
                        <Form.Item
                            label="User ID"
                            name="userId"
                            rules={[{ required: true, message: "Please input your User ID!" }]}
                        >
                            <Input
                                value={userId}
                                onChange={e => setUserId(e.target.value)}
                                placeholder="Enter User ID"
                                style={{ width: 300 }}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary"
                                    htmlType="submit"
                                    onClick={() => handleQuickLogin(userId)}>
                                Log in
                            </Button>
                        </Form.Item>
                    </Form>
                    <Form layout="vertical">
                        <Form.Item>
                            <Button
                                type="default"
                                htmlType="submit"
                                style={{ marginTop: 10 }}
                                loading={loading}
                                onClick={() => handlePublicLogin()}
                            >
                                Public Log in
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
            <Divider />
            <h4>Quick Login</h4>
            <Divider />
            <Row gutter={[16, 16]}>
                {quickUsers.map((user) => (
                    <Col span={12} key={user.userId}>
                        <Button
                            block
                            type="primary"
                            shape="round"
                            onClick={() => handleQuickLogin(user.userId)}
                            loading={loading}
                        >
                            {user.label}
                        </Button>
                    </Col>
                ))}
            </Row>
        </div>
    );
}